import { useQuery } from '@tanstack/react-query';

import { CapacityStatistics } from 'src/features/statistic/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/stats/capacity-stats/`;

type QueryFnType = typeof queryFn;

interface DTO {
    from_datetime: string;
    time: string;
    parkingId: string;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<CapacityStatistics> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_CAPACITY_STATISTIC_RESOURCE, useQueryHook as useGetCapacityStatistic };
